import { RepositoryPrivilege } from 'src/sections/repository/types';

import { FileMeta } from '../types';

export function canWrite(repoAccessLevel?: RepositoryPrivilege): boolean {
  return repoAccessLevel === 'write' || repoAccessLevel === 'admin';
}

export function isImage(meta: FileMeta): boolean {
  const { mimetype } = meta;
  // Mimetype libraries define `.fbs` files as `image/vnd.fastbidsheet`,
  // but we want to treat this ext as either FlatBuffer schema (text)
  // or FastBid sheet (binary).
  // See this PR: https://bitbucket.org/bitbucket/core/pull-requests/108020
  return !!(
    mimetype &&
    /^image\//.test(mimetype) &&
    mimetype !== 'image/vnd.fastbidsheet'
  );
}

export function isBinary(meta: FileMeta): boolean {
  return !!meta.attributes?.includes('binary');
}

export function isLFS(meta: FileMeta): boolean {
  return !!meta.attributes?.includes('lfs');
}
